import {useSelector} from 'react-redux';
import {selectUser} from '~/common/fabric/User/reducers/user';
import {Typography} from '~library/atoms/Typography';

import * as styles from './UserAvatar.module.scss';

export const UserAvatar = ({height = 24, width = 24}) => {
  const user = useSelector(selectUser);

  const hasUserImage =
    (user.image_url && user.image_url !== 'None') || (user.imgUrl && user.imgUrl !== 'None');
  const userImage = user.image_url || user.imgUrl;

  return (
    <div className={styles.userAvatar} style={{height, width}}>
      {hasUserImage ? (
        <img src={userImage} alt="Profile" />
      ) : (
        <Typography as="p" variant="paragraph4" data-qa-id="userAvatarInitials">
          {user.initials}
        </Typography>
      )}
    </div>
  );
};
